/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from '../../contexts/userContext';
import { AIRLINES } from '../../constants/appConstants';

/* Components */
import ReportsPageHeader from "../../components/reportsPageHeader";
import ReportsTabbedNavAA from '../../components/reportsTabbedNav/reportsTabbedNavAA';
import ReportsTabbedNavCHOICE from '../../components/reportsTabbedNav/reportsTabbedNavCHOICE';

/* Styles */
import styles from "./styles";


const Reports = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const renderReportsTab = () => {
    switch (providerCode) {
      case AIRLINES.AA:
        return <ReportsTabbedNavAA />;
      case AIRLINES.CHOICE:
        return <ReportsTabbedNavCHOICE />;
      default:
        return <ReportsTabbedNavAA />
    }
  }

  return (
    <div className={ classes.reportsPage }>
        <ReportsPageHeader />
        { renderReportsTab() }
    </div>
  )
}

export default Reports;
